import { apiService } from "./apiService";
import apiRoutes from "./apiRoutes";


export const getDashboard = async () => {
    const response = await apiService.get(apiRoutes.adminDashboard);
    return response.data;
};



export const getUserStats = async ( period ) => {
  const response = await apiService.get(apiRoutes.adminUserStats + `?period=${period}`);
  return response.data;
};

export const getRevenueStats = async ( period ) => {
  const response = await apiService.get(apiRoutes.adminRevenueStats + `?period=${period}`);
  return response.data;
};
